export function formatAlreadyScheduled(committedCount) {
  if (committedCount == null || Number.isNaN(Number(committedCount))) {
    return null
  }

  const value = Math.max(0, Number(committedCount))
  return `approx. ${value} already scheduled`
}
